import React, { useEffect, useState } from "react";
import { useForm } from 'react-hook-form';

// reactstrap components
import { Button, Card, CardBody, Input, Row, Col, Container, Form, Tooltip } from "reactstrap";

// services
import { showMessage } from "../../../services/message.js";
import { api_GET } from "../../../services/api_service.js";
import { EnviaProtocoloGeradorCaracterizacaoResiduo, EnviaRequerimentoGeradorCaracterizacaoResiduo } from "../../../services/protocolo_gerador_service.js";

//Context
import { useAuth } from "../../../context/auth";

export default function CaracterizacaoResiduos({ item, tipoCadastro, opcao, permiteManutencao, handleProximoStep, handleStepAnterior }) {
    const {session, setLoading} = useAuth();

    const { register, handleSubmit } = useForm({ mode: "onBlur" });

    const [permiteEditar, set_permiteEditar] = useState(true);

    const [registro, set_registro] = useState(null);

    const [lista, set_lista] = useState([]);

    const [listTipoAcondicionamento, set_listTipoAcondicionamento] = useState([]);

    const loadRegistro = () => {
        set_registro(item);
        api_GET('CaracterizacaoResiduosConama')
            .then(result => {
                let _lista = [];
                if (opcao && opcao.categoria.sigla == "RGG")
                    _lista = result.data.filter(x => x.sigla == "RGG");
                else
                    _lista = result.data.filter(x => x.sigla != "RGG");

                if (tipoCadastro == "Protocolo") {
                    if (item != null && item.protocoloGerador.length > 0 && item.protocoloGerador[0].protocoloGeradorCaracterizacaoResiduos) {
                        _lista.map(m => {
                            if (item.protocoloGerador[0].protocoloGeradorCaracterizacaoResiduos.filter(f => f.caracterizacaoResiduosConama_Id == m.caracterizacaoResiduosConama_Id).length > 0) {
                                let _protocoloGeradorCaracterizacaoResiduos = item.protocoloGerador[0].protocoloGeradorCaracterizacaoResiduos.filter(f => f.caracterizacaoResiduosConama_Id == m.caracterizacaoResiduosConama_Id)[0];
                                m.protocoloGeradorCaracterizacaoResiduo_Id = _protocoloGeradorCaracterizacaoResiduos ? _protocoloGeradorCaracterizacaoResiduos.protocoloGeradorCaracterizacaoResiduo_Id : 0;
                                m.quantidade = _protocoloGeradorCaracterizacaoResiduos ? _protocoloGeradorCaracterizacaoResiduos.quantidadeEstimada : "";
                            }
                        });
                    }
                }
                else if (tipoCadastro == "Requerimento") {
                    if (item != null && item.requerimentoGeradorCaracterizacaoResiduo) {
                        _lista.map(m => {
                            if (item.requerimentoGeradorCaracterizacaoResiduo.filter(f => f.caracterizacaoResiduosConama_Id == m.caracterizacaoResiduosConama_Id).length > 0) {
                                let _requerimentoGeradorCaracterizacaoResiduo = item.requerimentoGeradorCaracterizacaoResiduo.filter(f => f.caracterizacaoResiduosConama_Id == m.caracterizacaoResiduosConama_Id)[0];
                                m.requerimentoGeradorCaracterizacaoResiduo_Id = _requerimentoGeradorCaracterizacaoResiduo ? _requerimentoGeradorCaracterizacaoResiduo.requerimentoGeradorCaracterizacaoResiduo_Id : 0;
                                m.quantidade = _requerimentoGeradorCaracterizacaoResiduo ? _requerimentoGeradorCaracterizacaoResiduo.quantidadeEstimada : "";
                            }
                        })
                    }
                }
                set_lista(_lista);
            })
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    const loadTipoAcondicionamento = () => {
        api_GET('TipoAcondicionamento')
            .then(result => set_listTipoAcondicionamento(result.data))
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    useEffect(() => {
        if (opcao?.categoria?.sigla == "RGG")
            loadTipoAcondicionamento();

        loadRegistro();
    }, []);

    const handleBlurQuantidade = (_caracterizacaoResiduosConama_Id, value) => {
        let _lista = [];
        lista.map(m => {
            if (m.caracterizacaoResiduosConama_Id == _caracterizacaoResiduosConama_Id)
                m.quantidade = value;

            _lista.push(m);
        })
        set_lista(_lista);
    }

    const onSubmit = (data) => {
        setLoading(true);
        if (tipoCadastro == "Protocolo") {
            if (permiteEditar) {
                let json = carregaJsonProtocolo();
                EnviaProtocoloGeradorCaracterizacaoResiduo(json, true, confirmaCaracterizacaoResiduos)
            }
            else {
                handleProximoStep(registro);
            }
        }
        else if (tipoCadastro == "Requerimento") {
            let json = carregaJsonRequerimento();
            EnviaRequerimentoGeradorCaracterizacaoResiduo(json, confirmaCaracterizacaoResiduos)
        }
    }

    const carregaJsonProtocolo = () => {
        let json_submit = [];
        lista.map(m => {
            json_submit.push({
                protocoloGeradorCaracterizacaoResiduo_Id: m.protocoloGeradorCaracterizacaoResiduo_Id ? m.protocoloGeradorCaracterizacaoResiduo_Id : 0,
                protocoloGerador_Id: item.protocoloGerador[0].protocoloGerador_Id,
                caracterizacaoResiduosConama_Id: m.caracterizacaoResiduosConama_Id,
                quantidadeEstimada: m.quantidade ? m.quantidade : 0,
                usuarioUltimaAlteracao_Id: session != null && session.tipoAcesso == "AreaRestrita" ? session.usuario_Id : null
            });
        });

        return json_submit;
    }
    const carregaJsonRequerimento = () => {
        let json_submit = [];
        lista.map(m => {
            json_submit.push({
                requerimentoGeradorCaracterizacaoResiduo_Id: m.requerimentoGeradorCaracterizacaoResiduo_Id ? m.requerimentoGeradorCaracterizacaoResiduo_Id : 0,
                requerimento_Id: item.requerimento_Id,
                caracterizacaoResiduosConama_Id: m.caracterizacaoResiduosConama_Id,
                quantidadeEstimada: m.quantidade ? m.quantidade : 0,
                usuarioUltimaAlteracao_Id: session != null && session.tipoAcesso == "AreaRestrita" ? session.usuario_Id : null
            });
        });

        return json_submit;
    }

    const confirmaCaracterizacaoResiduos = (result) => {
        setLoading(false);
        let _registro = registro;
        if (tipoCadastro == "Protocolo")
            _registro.protocoloGerador[0].protocoloGeradorCaracterizacaoResiduos = result.data;
        else
            _registro.requerimentoGeradorCaracterizacaoResiduo = result.data;

        handleProximoStep(_registro);
    }

    const [tooltipActive, setTooltipActive] = useState({
        indice: "",
        active: false
    })
    const handleTooltipAtive = ({ key }) => {
        setTooltipActive({
            indice: key,
            active: !tooltipActive.active
        })
    }

    return (
        <>
            <div>
                <Card className={`card-stats`}>
                    <CardBody>
                        <Container style={{ maxWidth: "1000px", margin: "20px auto" }}>
                            <Form onSubmit={handleSubmit(onSubmit)}>
                                <h2 className="titulo-solicitacao">Caracterização dos Resíduos</h2>
                                <Row>
                                    <Col md="1">
                                        <strong>Grupo</strong>
                                    </Col>
                                    <Col md={"1"}>
                                        <strong>Código</strong>
                                    </Col>
                                    <Col md="1">
                                        <strong>Tipo</strong>
                                    </Col>

                                    <Col md="6">
                                        <strong>Descrição</strong>
                                    </Col>
                                    <Col md="2">
                                        <strong>Quantidade {lista[0]?.sigla == "RSS" ? '(Kg/dia)' : '(Litros/dia)'}</strong>
                                    </Col>
                                    <Col md="1">
                                        <strong></strong>
                                    </Col>
                                </Row>

                                {lista.map((m, key) => (
                                    <Row key={key} style={{ borderBottom: "1px solid #ccc", paddingTop: "10px", paddingBottom: "10px" }} className="align-items-center">

                                        <Col md="1">
                                            <label>{m?.grupo}</label>
                                        </Col>

                                        <Col md={"1"}>
                                            <label>{m.codigo}</label>
                                        </Col>

                                        <Col md="1">
                                            <label>{m?.tipo}</label>
                                        </Col>

                                        <Col md="6">
                                            <label>{m.descricao}</label>
                                        </Col>
                                        <Col md="2">
                                            <Input
                                                type="number"
                                                defaultValue={m.quantidade}
                                                innerRef={register({ required: false })}
                                                maxLength="100"
                                                readonly={permiteEditar ? false : "readonly"}
                                                onBlur={(e) => handleBlurQuantidade(m.caracterizacaoResiduosConama_Id, e.target.value)}
                                            />
                                        </Col>
                                        {m.descricaoTipoAcondicionamento &&
                                            <Col md="1">
                                                <div className="w-100 d-flex justify-content-end pt-1 pr-2 " >
                                                    <span id={"tooltip-" + key} className=" me-4 p-1 d-flex justify-content-center align-items-center" style={{ borderRadius: '100%', width: '30px', height: '30px', border: '3px solid #666', fontSize: '16px', fontWeight: 'bold', color: '#666' }}>?</span>
                                                </div>
                                            </Col>
                                        }
                                        {m.descricaoTipoAcondicionamento &&
                                            <Tooltip
                                                isOpen={tooltipActive.indice == key && tooltipActive.active}
                                                placement="top"
                                                target={"tooltip-" + key}
                                                toggle={() => handleTooltipAtive({ key: key })}
                                            >
                                                {m.descricaoTipoAcondicionamento}
                                            </Tooltip>
                                        }
                                    </Row>
                                ))}

                                <Row>
                                    <Col lg="6" className="text-left">
                                        <Button color="secundary" onClick={() => handleStepAnterior(registro)} className="btn-mobile" type="submit"><i className="fas fa-chevron-left"></i> Voltar</Button>
                                    </Col>
                                    <Col lg="6" className="text-right">
                                        <Button color="success" className="btn-mobile" type="submit">Próxima Etapa  <i className="fas fa-chevron-right"></i></Button>
                                    </Col>
                                </Row>
                            </Form>
                        </Container>
                    </CardBody>
                </Card>
            </div>
        </>
    );
}